
import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 列表列表
 */
export function getReceiveInvoiceList(data) {
  return fetch({
    url: '/financial/receive/invoice/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除单据
 */
export function deleteReceiveInvoice(data) {
  return fetch({
    url: '/financial/receive/invoice/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function saveReceiveInvoice(data) {
  return fetch({
    url: '/financial/receive/invoice/save',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function getReceiveInvoiceTypeList() {
  return fetch({
    url: '/financial/receive/invoice/getReceiveInvoiceTypeList',
    method: 'GET',
  })
}






// WEBPACK FOOTER //
// ./src/api/ReceiveInvoice/index.js